
import React from 'react'
import { Box, Typography, TextField, Select, FormControl,MenuItem } from '@mui/material'
import ValidationErrorText from '../components/common/ValidationErrorText'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { currentyList } from './common/CommonFilterTab';


const CurrenyAmtFieldInput = ({ label, value, readOnly = false, placeholder = '', onChange,fieldError,fieldType,fieldErrors }) => {

    const handleOnChange = (newValue, type) => {
        if(!["amount","currency"]?.includes(type)) return
        
        if (type == "amount") {
            const rawValue = newValue?.replace(/,/g, "");
            if (!/^\d*\.?\d{0,2}$/.test(rawValue)) return
        }
        onChange({ ...value, [type]: newValue })
    }

  return (
    <Box width="100%">
                        <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "#363853", mb: "7px" }}>
                            {label}
                        </Typography>
                        <Box display="flex" alignItems="center" width="100%">
                            {/* Text input */}
                            <TextField
                                fullWidth
                                value={value?.amount}
                                disabled={readOnly}
                                onChange={(e)=>handleOnChange(e?.target?.value,"amount")}
                                variant="outlined"
                                placeholder={placeholder ?? "00"}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        height: "40px", // match Select height
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 0,
                                    },
                                }}
                            />

                            {/* Dropdown */}
                            <FormControl sx={{ minWidth: 80 }}>
                                <Select
                                    value={value?.currency}
                                    onChange={(e)=>handleOnChange(e?.target?.value,"currency")}
                                    displayEmpty
                                    IconComponent={KeyboardArrowDownIcon}
                                    disabled={readOnly}
                                    sx={{
                                        marginLeft: '-1px',
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                        },
                                        "& .MuiSelect-select": {
                                            padding: "0px 12px",
                                            height: "40px !important",
                                            display: "flex",
                                            alignItems: "center",
                                        },
                                    }}
                                >
                                    {currentyList?.map(item => <MenuItem key={item?.value} value={item?.value}>
                                        <em>{item.label}</em>
                                    </MenuItem>)}
                                </Select>
                            </FormControl>
                        </Box>
                    <ValidationErrorText error={fieldErrors?.[`${fieldType}.amount`] || fieldErrors?.[`${fieldType}.currency`] || fieldError}/>
                    </Box>
  )
}

export default CurrenyAmtFieldInput
